//codex--
import axios from 'axios';

//codex--
export const SCHEDULER_DEPARTMENTS = ['Field', 'Service', 'Maintenance', 'Install', 'Admin', 'Purchasing'];
export const normalizeSchedulerDepartment = (value) =>
  value === '' || SCHEDULER_DEPARTMENTS.includes(value) ? value : 'Field';

//codex--
export async function getFullSchedulerDefault(apiUrl) {
  const response = await axios.get(`${apiUrl}/config_system_crud.php`, {
    params: { getFullScheduler: true },
  });
  if (response.data?.success !== true) throw new Error('Could not load your default department.');
  return normalizeSchedulerDepartment(response.data.default_department);
}

//codex--
export async function saveFullSchedulerDefault(apiUrl, department) {
  const response = await axios.post(`${apiUrl}/config_system_crud.php`, {
    status: 'saveFullScheduler',
    data: { default_department: department },
  }, { headers: { 'Content-Type': 'application/json' } });
  if (response.data?.success !== true) throw new Error('Could not save your default department.');
  return normalizeSchedulerDepartment(response.data.default_department);
}
